<template>
  <HexGrid :mouseX="mouseX" :mouseY="mouseY" />

  <div id="app" @mousemove="updateMouse">
    <MainHeader />
    <router-view />
    <SiteFooter />
    
    <ChatWidget />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import MainHeader from "./components/MainHeader.vue";
import SiteFooter from "./components/SiteFooter.vue";
import HexGrid from "./components/HexGrid.vue";
import "@fortawesome/fontawesome-free/css/all.css";

const mouseX = ref(0);
const mouseY = ref(0);

function updateMouse(event) {
  mouseX.value = event.clientX;
  mouseY.value = event.clientY;
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap");

/* Estilos globais */
body {
  margin: 0;
  padding: 0;
  background-color: #000;
}

#app {
  position: relative;
  z-index: 2; 
  background-color: transparent;
  width: 100%;
  min-height: 100vh;
}

/* Responsividade */
@media (max-width: 768px) {
  h2 {
    font-size: 1.5rem;
    text-align: center;
  }
}

/* 2. CORREÇÃO DE FUNDO BRANCO (BOOTSTRAP)
   Isso garante que o grid apareça atrás do conteúdo 
*/
.container, .container-fluid, .row, section, main {
  background-color: transparent !important;
}

.card {
  /* Deixa os cards com efeito de vidro escuro */
  background-color: rgba(30, 30, 30, 0.6) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: white !important;
}
</style>